import { render, staticRenderFns } from "./NpsWidget.vue?vue&type=template&id=39588261&scoped=true"
import script from "./NpsWidget.vue?vue&type=script&lang=js"
export * from "./NpsWidget.vue?vue&type=script&lang=js"
import style0 from "./NpsWidget.vue?vue&type=style&index=0&id=39588261&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39588261",
  null
  
)

export default component.exports